import { ENDPOINT } from "../../config";
import axios from "axios";
import * as queryString from "query-string";

// Default state
const defaultState = () => {
  return {
    authUserIsLoading: false,
    registerUserLoading: false,
    createEventIsLoading: false,
    waitingListUserIsLoading: false,
    error: null,
    userData: null,
  };
};

// State object
const state = defaultState();

// Getter functions
const getters = {
  getUserData(state) {
    return state.userData;
  },
  getUserError(state) {
    return state.error;
  },
  getUserRegisterLoading(state) {
    return state.registerUserLoading;
  },
  getCreateEventIsLoading(state) {
    return state.createEventIsLoading;
  },
  getWaitingListUserIsLoading(state) {
    return state.waitingListUserIsLoading;
  },
};

// Actions
const actions = {
  async createEvent({ commit }, data) {
    commit("SET_USER_CREATE_EVENT_IS_LOADING", true);

    return new Promise((resolve, reject) => {
      axios
        .post(ENDPOINT.addParentChildPhobias, data)
        .then((response) => {
          commit("SET_USER_CREATE_EVENT_IS_LOADING", false);
          resolve(response.data);
        })
        .catch((error) => {
          commit("SET_USER_CREATE_EVENT_IS_LOADING", false);

          if (error.response) {
            commit("SET_ERROR", error.response.data);
            reject(error.response.data);
          } else {
            const errorText =
              "Something went wrong trying to set up your account. Please contact ovrcome support: support@ovrcome.io";

            commit("SET_ERROR", errorText);
            reject(errorText);
          }
        });
    });
  },
  async registerUser({ commit }, payload) {
    commit("SET_REGISTER_USER_LOADING", true);

    delete payload?.paymentType;

    return new Promise((resolve, reject) => {
      axios
        .post(`${ENDPOINT.registerUser}`, payload)
        .then((response) => {
          commit("SET_REGISTER_USER_LOADING", false);
          commit("SET_USER_DATA", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            commit("SET_ERROR", error.response.data);
          }

          commit("SET_REGISTER_USER_LOADING", false);
          reject(error.response.data);
        });
    });
  },
  async updateUser({ commit }, payload) {
    commit("SET_REGISTER_USER_LOADING", true);

    const query = queryString.stringify(payload);

    return new Promise((resolve, reject) => {
      axios
        .post(`${ENDPOINT.userData}?${query}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            commit("SET_ERROR", error.response.data);
          }

          reject(error.response.data);
        });
    });
  },
  async authenticateUser({ commit }, payload) {
    commit("AUTH_USER_IS_LOADING", true);

    const query = queryString.stringify(payload);

    return new Promise((resolve, reject) => {
      axios
        .post(`${ENDPOINT.authUser}?${query}`)
        .then((response) => {
          commit("AUTH_USER_IS_LOADING", false);
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            commit("SET_ERROR", error.response.data);
          }

          commit("AUTH_USER_IS_LOADING", false);
          reject(error.response.data);
        });
    });
  },
  async fetchUser({ commit }) {
    commit("FETCH_USER_IS_LOADING", true);

    return new Promise((resolve, reject) => {
      axios
        .post(ENDPOINT.userData)
        .then((response) => {
          commit("FETCH_USER_IS_LOADING", false);
          commit("SET_USER_DATA", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            commit("SET_ERROR", error.response.data);
          }

          commit("FETCH_USER_IS_LOADING", false);
          reject(error.response.data);
        });
    });
  },
  async waitingListUser({ commit }, payload) {
    commit("WAITING_LIST_USER_IS_LOADING", true);

    const query = queryString.stringify(payload);

    return new Promise((resolve, reject) => {
      axios
        .post(`${ENDPOINT.waitingList}?${query}`)
        .then((response) => {
          commit("WAITING_LIST_USER_IS_LOADING", false);
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            commit("SET_ERROR", error.response.data);
          }

          commit("WAITING_LIST_USER_IS_LOADING", false);
          reject(error.response.data);
        });
    });
  },
  resetState({ commit }) {
    commit("RESET_STATE");
  },
};

// Mutations
const mutations = {
  SET_USER_DATA(state, userData) {
    state.userData = userData;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_REGISTER_USER_LOADING(state, isLoading) {
    state.registerUserLoading = isLoading;
  },
  FETCH_USER_IS_LOADING(state, isLoading) {
    state.registerUserLoading = isLoading;
  },
  AUTH_USER_IS_LOADING(state, isLoading) {
    state.authUserIsLoading = isLoading;
  },
  SET_USER_CREATE_EVENT_IS_LOADING(state, isLoading) {
    state.createEventIsLoading = isLoading;
  },
  WAITING_LIST_USER_IS_LOADING(state, isLoading) {
    state.waitingListUserIsLoading = isLoading;
  },
  RESET_STATE(state) {
    Object.assign(state, defaultState());
  },
};

export default {
  name: "UserModule",
  dynamic: true,
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
